import { render, staticRenderFns } from "./bookingSettingIndex.vue?vue&type=template&id=000469a2&scoped=true"
import script from "./bookingSettingIndex.vue?vue&type=script&lang=js"
export * from "./bookingSettingIndex.vue?vue&type=script&lang=js"
import style0 from "./bookingSettingIndex.vue?vue&type=style&index=0&id=000469a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000469a2",
  null
  
)

export default component.exports